/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Event_Metrics_Wpm_UnitInputs */



/**
* | output |
* | --- |
* | "wpm" |
*
* @param {Event_Metrics_Wpm_UnitInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const event_metrics_wpm_unit = /** @type {((inputs?: Event_Metrics_Wpm_UnitInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Event_Metrics_Wpm_UnitInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("mpm")
	if (locale === "de") return /** @type {LocalizedString} */ ("Wörter pro Minute")
	if (locale === "it") return /** @type {LocalizedString} */ ("parole al minuto")
	if (locale === "ru") return /** @type {LocalizedString} */ ("слов в минуту")
	if (locale === "es") return /** @type {LocalizedString} */ ("palabras por minuto")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("每分钟字数")
	if (locale === "ja") return /** @type {LocalizedString} */ ("1分あたり")
	if (locale === "hi") return /** @type {LocalizedString} */ ("wpm")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("palavras por minuto")
	return /** @type {LocalizedString} */ ("wpm")
});